import {createApi} from '@reduxjs/toolkit/query/react';
import {customBaseQuery} from '~/common/rtk-query/queries';

export const api = createApi({
  reducerPath: 'oneStepEventAPI',
  baseQuery: customBaseQuery,
  tagTypes: ['Event', 'Assets'],
  endpoints: () => ({}),
});
